import { addUsersMessageId } from 'modules/account/AccountService2';
import { TenantRoles } from 'modules/application/tenant/TenantService';
import { ItemsInHeader, ListApplicationsAccount } from 'modules/shared/ApplicationTypings';
import { Contexts } from 'modules/core/ContextProcessorService';
import { ListApplicationFeatures } from '../ListApplicationFeatures';
import { ORGANIZATION_MIGRATION_CONFIRM_BUTTON, ORGANIZATION_CHATBOTS_SEARCH, ORGANIZATION_MIGRATION_TAB_CLOSE, ORGANIZATION_NOT_ALLOWED_ALERT_CANCEL, } from '../../tenant/TenantSegmentEvents';
import foldToASCII from 'data/foldToASCII';
import * as angular from 'angular';
import BotMigrationModalView from 'modules/contact/botMigrationModal/BotMigrationModalView.html';
import BotMigrationModalContractToContractView from 'modules/contact/botMigrationModal/BotMigrationModalContractToContractView.html';
import { BotMigrationModalController } from 'modules/contact/botMigrationModal/BotMigrationModalController';
import RouterMigrationModalView from 'modules/contact/routerMigrationModal/RouterMigrationModalView.html';
import { RouterMigrationModalController } from 'modules/contact/routerMigrationModal/RouterMigrationModalController';
import PlaceholderIcon from 'assets/img/icons/business.svg';
import { TenantFeatures } from 'modules/application/tenant/TenantFeatures';
const OnSeachEvent = 'OnSeachEvent';
const LSAddedToNotificationList = 'blip-portal:addedToNotificationList'; // LS = local storage
const FORBIDDEN_USER_ALERT_CANCEL = 'application-forbidden-user-alert-cancel';
const MASTER = 'master';
const BUILDER = 'builder';
const AI_AGENT = 'aiAgent';
export class MoveApplicationToTenantController {
    static $inject = ['$state', '$rootScope', '$window', 'ApplicationService2', 'LoadingService', 'ngToast', '$translate', 'ModalService', 'AccountService2', 'BlipService', 'AuthenticationService', 'ContextProcessorService', '$stateParams', 'TenantService', 'SegmentService', 'BLIP_DOMAIN', 'SharedToastsService', 'BlipToastService'];
    constructor($state, $rootScope, $window, ApplicationService2, LoadingService, ngToast, $translate, ModalService, AccountService2, BlipService, AuthenticationService, ContextProcessorService, $stateParams, TenantService, SegmentService, BLIP_DOMAIN, SharedToastsService, 
    // OLD COMPONENT
    $scope, BlipToastService) {
        'ngInject';
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.ApplicationService2 = ApplicationService2;
        this.LoadingService = LoadingService;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.AccountService2 = AccountService2;
        this.BlipService = BlipService;
        this.AuthenticationService = AuthenticationService;
        this.ContextProcessorService = ContextProcessorService;
        this.$stateParams = $stateParams;
        this.TenantService = TenantService;
        this.SegmentService = SegmentService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.SharedToastsService = SharedToastsService;
        this.$scope = $scope;
        this.BlipToastService = BlipToastService;
        this.defaultNotFoundMessage = 'listViewApplication.noneRegistered';
        this.noSearchResultsMessage = 'listViewApplication.chatbotNotFound';
        this.isQueryingApplications = false;
        this.hasAcessAdminTenant = false;
        this.counterRouter = 0;
        this.counterBuilder = 0;
        this.counterTotal = 0;
        this.stepOneVisible = true;
        this.placeholderIcon = PlaceholderIcon;
        this.routerChecked = true;
        this.builderChecked = true;
        this.skip = 1;
        this.isSkipPage = false;
        this.totalNumberPages = 0;
        this.totalNumberItems = 0;
        this.isItemPerPage = false;
        this.listItemsPerPage = [40, 80, 120];
        this.isRefreshing = false;
        this.showPagination = false;
        this.onCheckedRouter = async (event) => {
            this.routerChecked = event.detail.checked;
            this.filterApplications(this.routerChecked, this.builderChecked);
        };
        this.onCheckedBuilder = async (event) => {
            this.builderChecked = event.detail.checked;
            this.filterApplications(this.routerChecked, this.builderChecked);
        };
        this.setTotalPagination = () => {
            this.LoadingService.startLoading();
            const total = this.totalApplications = this.isQueryingApplications ? this.searchResults.length : this.applicationsBuffer.length;
            this.totalNumberPages = total ? Math.ceil(total / this.itemsPerPage) : 1;
            this.totalNumberItems = total ? total : 0;
            this.loadPerItem();
            this.LoadingService.stopLoading();
        };
        this.onChangePage = async (page) => {
            this.isSkipPage = true;
            await this.refreshList(page);
        };
        this.refreshList = async (page) => {
            this.LoadingService.startLoading();
            if (this.isRefreshing) {
                return;
            }
            this.isRefreshing = true;
            try {
                if (this.isSkipPage) {
                    this.skip = (page.detail - 1) * this.itemsPerPage;
                    this.page = page.detail;
                    await this.loadSkipPage();
                }
            }
            finally {
                this.isRefreshing = false;
                this.LoadingService.stopLoading();
            }
        };
        this.onChangeItemPerPage = async (itemsPerPage, skip) => {
            this.itemsPerPage = typeof itemsPerPage === 'string' ? Number(itemsPerPage) : itemsPerPage;
            this.totalNumberPages = 0;
            this.totalNumberItems = 0;
            this.setTotalPagination();
        };
        this.onChangeItem = (event) => {
            const { detail: { value } } = event;
            this.itemsPerPage = typeof value === 'string' ? Number(value) : value;
            this.onChangeItemPerPage(this.itemsPerPage, 1);
        };
        this.getPaginationLabel = () => {
            return {
                start: ((this.page - 1) * this.itemsPerPage + 1),
                end: (this.page * this.itemsPerPage < this.totalApplications ? this.page * this.itemsPerPage : this.totalApplications),
                total: this.totalApplications,
            };
        };
        this.noSearchResults = false;
        this.$rootScope.$on(OnSeachEvent, (_, text) => this.onSearchBots(text));
        this.tenantName = this.$stateParams.tenantName && decodeURIComponent(this.$stateParams.tenantName);
        this.applicationShortName = this.$stateParams.shortName;
        this.emailOwner = '';
        this.headerMessage = 'applicationsMigration.step1.elementsInExhibition';
        this.checkedMasterApplications = [];
        this.checkedBuilderApplications = [];
        this.children = [];
        this.$scope.$watch('$ctrl.checkedApplications', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.checkedMasterApplications = newValue.filter(application => application.template === MASTER);
                this.checkedBuilderApplications = newValue.filter(application => application.template === BUILDER);
            }
        }, true);
    }
    async $onInit() {
        this.LoadingService.startLoading(false);
        try {
            await this.checkFeatures();
            const userAddedToNotificationListKey = `${LSAddedToNotificationList}-${this.AuthenticationService.email}`;
            if (localStorage.getItem(userAddedToNotificationListKey) !== 'true') {
                // Add user to portal broadcast list for notifications bot
                this.addUserToNotificationsBroadcastList();
                localStorage.setItem(userAddedToNotificationListKey, 'true');
            }
            if (this.isOrganizationEnabled) {
                await this.bindBlipAccount();
                const userIdentity = `${encodeURIComponent(this.blipAccount.email)}@${this.BLIP_DOMAIN}`;
                await this.ContextProcessorService.waitForInitialization();
                try {
                    if (this.ContextProcessorService.context === Contexts.Default) {
                        await this.configureApplicationsMigration();
                        this.canCreateChatBot = true;
                        await this.bindAllApplications();
                        await this.configPagination();
                        this.LoadingService.stopLoading();
                        return;
                    }
                    this.tenantId = this.ContextProcessorService.tenant.id;
                    await this.bindBlipAccount();
                    this.canCreateChatBot = await this.TenantService.hasRequiredTenantRole(userIdentity, this.tenantId, [TenantRoles.Admin, TenantRoles.Member]);
                    this.hasAcessAdminTenant = await this.TenantService.hasRequiredTenantRole(userIdentity, this.tenantId, [TenantRoles.Admin]);
                    const applicationsList = this.hasAcessAdminTenant
                        ? this.applications = await this.ApplicationService2.getApplicationsByTenant(this.tenantId)
                        : this.applications = await this.ApplicationService2.getApplications(this.tenantId);
                    this.applications = applicationsList.reverse();
                    this.applicationsBuffer = this.applications;
                    await this.configPagination();
                    if (this.applications.length) {
                        await this.configureApplicationsMigration(this.tenantId);
                    }
                    return;
                }
                catch (e) {
                    const errorMsg3 = await this.$translate('utils.errorMsg.3');
                    this.ngToast.danger(errorMsg3);
                    console.error(e);
                }
                finally {
                    this.isMovingChatbots = this.$stateParams.isMovingChatbots ? true : false;
                    this.LoadingService.stopLoading();
                }
            }
            else {
                this.canCreateChatBot = true;
                await this.bindAllApplications();
                await this.configPagination();
                this.LoadingService.stopLoading();
            }
        }
        catch (e) {
            console.error(e);
            const errorMsg3 = await this.$translate('utils.errorMsg.3');
            this.ngToast.danger(errorMsg3);
        }
        finally {
            this.LoadingService.stopLoading();
            if (this.$stateParams.forbidden) {
                const currentApplication = this.applications.filter(a => a.shortName == this.applicationShortName);
                if (currentApplication.length > 0) {
                    this.emailOwner = currentApplication[0].emailOwner;
                }
                await this.forbiddenUserAlertToggle();
            }
            await this.SharedToastsService.showLeaveContractToast();
            await this.getTenantOptions();
            this.listApplicationsWithChildren = new ListApplicationsAccount();
            this.listApplicationsWithChildren.itemsInHeader = [];
        }
    }
    async getTenantOptions() {
        this.tenantsUsers = (await this.TenantService.tenantUsersMine()).items;
        const currentTenantId = this.TenantService.getTenantPrefixFromUrl();
        this.tenantSelectOptions = this.tenantsUsers.reduce((accumulator, tenantUser) => {
            if (tenantUser.tenant.id !== currentTenantId) {
                const tenant = tenantUser.tenant;
                const iconHtml = tenant.photoUri
                    ? `<img class='tenant-image' src='${tenant.photoUri}'/>`
                    : `<span class='icon icon-sm round bp-bg-sky flex justify-center items-center'>
                                    <span class='icon icon-s icon-tenant'></span>
                                </span>`;
                accumulator.push({
                    value: tenant.id,
                    label: tenant.name,
                    description: this.TenantService.getTenantUrl(tenant.id, false),
                    icon: iconHtml,
                    disabled: tenantUser.roleId !== TenantRoles.Admin,
                });
            }
            return accumulator;
        }, []);
    }
    get notFoundMessage() {
        return this.noSearchResults
            ? this.noSearchResultsMessage
            : this.defaultNotFoundMessage;
    }
    async configureApplicationsMigration(tenantId) {
        this.checkedApplications = [];
        this.checkedMasterApplications = [];
        this.checkedBuilderApplications = [];
        this.adminApplications = await this.ApplicationService2.getAdminApplications(tenantId);
        this.canMigrateApplications = await ListApplicationFeatures.canMigrateBots();
    }
    async bindBlipAccount() {
        if (!this.blipAccount) {
            this.blipAccount = await this.AccountService2.me();
            const userExtras = this.isOrganizationEnabled
                ? { ...this.blipAccount.extras }
                : {
                    ...this.blipAccount.extras,
                    isOldUser: 'true',
                };
            await this.AccountService2.setExtras(userExtras);
        }
    }
    async bindAllApplications() {
        this.applications = await this.ApplicationService2.getApplications();
        this.applicationsBuffer = this.applications;
    }
    preserveApplicationsChecked(allApplications) {
        if (this.checkedApplications.length > 0 && allApplications.length > 0) {
            this.checkedApplications.forEach(checked => {
                const applicationFilter = allApplications.filter(element => element.shortName === checked.shortName);
                if (applicationFilter.length > 0) {
                    applicationFilter[0].checked = true;
                }
            });
        }
    }
    changeHeaderMessage(router, builder) {
        this.headerMessage = 'applicationsMigration.step1.elementsInExhibition';
        const sizeApplication = this.applications.length;
        if (sizeApplication > 1) {
            if (router && builder) {
                this.headerMessage = 'applicationsMigration.step1.elementsInExhibition';
            }
            else if (router) {
                this.headerMessage = 'applicationsMigration.step1.routersInExhibition';
            }
            else if (builder) {
                this.headerMessage = 'applicationsMigration.step1.buildersInExhibition';
            }
            else {
                this.headerMessage = 'applicationsMigration.step1.elementInExhibition';
            }
        }
        else {
            if (router && builder) {
                this.headerMessage = 'applicationsMigration.step1.elementInExhibition';
            }
            else if (router) {
                this.headerMessage = 'applicationsMigration.step1.routerInExhibition';
            }
            else if (builder) {
                this.headerMessage = 'applicationsMigration.step1.builderInExhibition';
            }
            else {
                this.headerMessage = 'applicationsMigration.step1.elementInExhibition';
            }
        }
    }
    async getAllApplications() {
        if (this.tenantId) {
            if (this.hasAcessAdminTenant) {
                return await this.ApplicationService2.getApplicationsByTenant(this.tenantId);
            }
            else {
                return await this.ApplicationService2.getApplications(this.tenantId);
            }
        }
        else {
            return await this.ApplicationService2.getApplications();
        }
    }
    async filterApplications(router, builder) {
        const allApplications = await this.getAllApplications();
        this.preserveApplicationsChecked(allApplications);
        if (router && builder) {
            this.applications = allApplications;
            this.applicationsBuffer = this.applications.reverse();
            this.configPagination();
        }
        else if (router) {
            this.applications = allApplications.filter(application => application.template === MASTER).reverse();
            this.applicationsBuffer = this.applications;
            this.configPagination();
        }
        else if (builder) {
            this.applications = allApplications.filter(application => application.template === BUILDER).reverse();
            this.applicationsBuffer = this.applications;
            this.configPagination();
        }
        else {
            this.applications = [];
            this.applicationsBuffer = this.applications;
            this.configPagination();
        }
        if (this.searchText !== undefined) {
            this.onSearchBots(this.searchText);
        }
        this.changeHeaderMessage(router, builder);
    }
    checkAllApplications() {
        this.applicationsBuffer.forEach(contact => {
            if (!contact.checked && contact.template !== AI_AGENT) {
                contact.checked = true;
                this.checkedApplications.push(contact);
                this.checkedApplications.sort((a, b) => a.created < b.created ? 1 : -1);
                this.addCounter(contact);
            }
        });
        this.checkRouterApplications();
    }
    uncheckAllApplications() {
        this.applicationsBuffer.forEach(contact => {
            if (contact.checked) {
                contact.checked = false;
                this.deleteCounter(contact);
            }
        });
        this.checkedApplications = [];
        this.uncheckRouterApplications();
    }
    checkRouterApplications() {
        const applications = angular.copy(this.applicationsBuffer);
        applications.forEach(contact => {
            this.flowCheckedRouter(contact);
        });
    }
    uncheckRouterApplications() {
        const itemsInHeaderToRemove = angular.copy(this.listApplicationsWithChildren.itemsInHeader);
        itemsInHeaderToRemove.forEach(item => {
            item.applications.forEach(contact => {
                this.flowUncheckedRouter(contact);
            });
        });
    }
    addCounter(contact) {
        if (contact.template === MASTER) {
            this.counterRouter = this.counterRouter + 1;
        }
        else {
            this.counterBuilder = this.counterBuilder + 1;
        }
    }
    deleteCounter(contact) {
        if (contact.template === MASTER) {
            this.counterRouter = this.counterRouter - 1;
        }
        else {
            this.counterBuilder = this.counterBuilder - 1;
        }
    }
    showStep(index) {
        if (index == 1) {
            this.stepOneVisible = true;
            this.stepTwoVisible = false;
            this.stepThreeVisible = false;
            this.checkedInExhibitionApplicationsStepTwo = [];
        }
        else if (index == 2) {
            this.stepOneVisible = false;
            this.stepTwoVisible = true;
            this.stepThreeVisible = false;
            this.createListCheckedInExhibition();
        }
        else {
            this.stepOneVisible = false;
            this.stepTwoVisible = false;
            this.stepThreeVisible = true;
        }
    }
    async checkFeatures() {
        try {
            this.isPaginationHomeInApplication = await TenantFeatures.paginationHomeInApplication();
            this.userProfileModalEnabled = await ListApplicationFeatures.userProfileModalEnabled();
            this.isOrganizationEnabled = await this.TenantService.isOrganizationEnabled();
        }
        catch (e) {
            throw e;
        }
    }
    onSearchBots(text) {
        const searchText = foldToASCII(text).toLowerCase();
        this.searchText = text;
        this.noSearchResults = false;
        this.isQueryingApplications = true;
        if (!this.applicationsBuffer) {
            this.applicationsBuffer = angular.copy(this.applications);
        }
        if (searchText.length > 2) {
            const searchResults = this.applicationsBuffer.filter((x) => foldToASCII(x.name)
                .toLowerCase()
                .includes(searchText));
            const tenant = this.isOrganizationEnabled && this.ContextProcessorService.tenant;
            if (tenant && tenant.id) {
                this.SegmentService.createTrack(ORGANIZATION_CHATBOTS_SEARCH, {
                    status: 'success',
                    organizationName: tenant.name,
                    organizationUrl: this.TenantService.getTenantUrl(tenant.id),
                    text: searchText,
                    qtdItens: searchResults.length,
                });
            }
            if (searchResults.length > 0) {
                this.applications = searchResults;
                this.searchResults = searchResults;
                this.configPagination();
            }
            else {
                this.applications = [];
                this.noSearchResults = true;
            }
        }
        else {
            this.applications = this.applicationsBuffer;
            this.isQueryingApplications = false;
            this.searchResults = undefined;
            this.searchText = undefined;
            this.filterApplications(this.routerChecked, this.builderChecked);
        }
    }
    async addUserToNotificationsBroadcastList() {
        if (!(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
        await this.BlipService.sendMessage({
            type: 'text/plain',
            content: '#addlist',
            to: 'notifications@msging.net',
            id: addUsersMessageId,
        });
    }
    async forbiddenUserAlertToggle() {
        this.SegmentService.createTrack(FORBIDDEN_USER_ALERT_CANCEL);
        const bdsAlert = document.querySelector('bds-alert[id=forbiddenUserAlertList]');
        await bdsAlert.toggle();
    }
    async notAllowedAlertToggle() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_NOT_ALLOWED_ALERT_CANCEL);
        const bdsAlert = document.querySelector('bds-alert[id=blockedTenant]');
        await bdsAlert.toggle();
    }
    async showDisabledTenantWarning(ev) {
        const tenantName = ev.optionProps.label;
        const title = await this.$translate('applicationsMigration.blockedTenantWarningTitle');
        const msg = await this.$translate('applicationsMigration.blockedTenantWarningBody', { tenantName });
        this.BlipToastService.show('warning', { title, msg });
    }
    async close() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_TAB_CLOSE, { checkedApplications: this.checkedApplications });
        this.$scope.$destroy();
        this.$state.go('auth.application.list');
    }
    async moveCheckedApplications() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_CONFIRM_BUTTON, { checkedApplications: this.checkedApplications });
        const selectedTenant = this.tenantsUsers.find(tenantUser => tenantUser.tenantId === this.selectedTenantId).tenant;
        this.selectedTenantName = selectedTenant.name;
        const applicationsShortNames = this.checkedApplications.sort((a, b) => (a.template > b.template) ? 1 : -1).map(application => application.shortName);
        const invalidMasterApplicationsIds = await this.fetchInvalidApplicationsToLinkTenant(applicationsShortNames);
        if (invalidMasterApplicationsIds.length) {
            const invalidMasterApplications = this.getInvalidMasterApplications(invalidMasterApplicationsIds);
            await this.openRouterMigrationModal(invalidMasterApplications);
        }
        else {
            const estimatedDate = await this.TenantService.getMigrationEstimatedDate(applicationsShortNames.length);
            await this.openBotMigrationModal(applicationsShortNames, selectedTenant, true, estimatedDate, this.tenantId);
        }
    }
    async fetchInvalidApplicationsToLinkTenant(applicationsShortNames) {
        try {
            this.LoadingService.startLoading();
            return await this.TenantService.getInvalidApplicationsToLinkTenant(applicationsShortNames, this.selectedTenantId);
        }
        catch (err) {
            console.error(err);
            const errroWhileMovingTitle = await this.$translate('applicationsMigration.errorWhileMovingTitle');
            const errorWhileMovingMsg = await this.$translate('applicationsMigration.errorWhileMovingMsg');
            this.BlipToastService.show('danger', {
                title: errroWhileMovingTitle,
                msg: errorWhileMovingMsg,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    getInvalidMasterApplications(invalidMasterApplicationsIds) {
        return this.checkedMasterApplications.filter(checkedMaster => invalidMasterApplicationsIds.includes(checkedMaster.shortName));
    }
    async openBotMigrationModal(applicationsShortNames, selectedTenant, isMovingChatbot, estimatedDate, tenantIdOrigin) {
        let migrationModal;
        if (this.ContextProcessorService.context === Contexts.Tenants) {
            migrationModal = await this.ModalService.showModal({
                template: BotMigrationModalContractToContractView,
                controller: BotMigrationModalController,
                controllerAs: '$ctrl',
                inputs: {
                    applicationsShortNames,
                    selectedTenant,
                    isMovingChatbot,
                    estimatedDate,
                    tenantIdOrigin,
                },
            });
        }
        else {
            migrationModal = await this.ModalService.showModal({
                template: BotMigrationModalView,
                controller: BotMigrationModalController,
                controllerAs: '$ctrl',
                inputs: {
                    applicationsShortNames,
                    selectedTenant,
                    isMovingChatbot,
                    estimatedDate,
                    tenantIdOrigin: this.tenantId,
                },
            });
        }
        const shouldClose = await migrationModal.close;
        const groupIdMigration = await migrationModal.controller.groupIdMigration;
        if (shouldClose === true) {
            const succesTitle = await this.$translate('applicationsMigration.step3.titleToast');
            const succesMsg = await this.$translate('applicationsMigration.step3.msgToast', { dateMigration: estimatedDate });
            await this.BlipToastService.show('info', {
                title: succesTitle,
                msg: succesMsg,
            });
            await this.getHistoricMigration(selectedTenant.id, groupIdMigration);
            this.finishMigration();
            this.showStep(3);
        }
    }
    async openRouterMigrationModal(invalidMasterApplications) {
        await this.ModalService.showModal({
            template: RouterMigrationModalView,
            controller: RouterMigrationModalController,
            controllerAs: '$ctrl',
            inputs: {
                invalidRouters: invalidMasterApplications,
            },
        });
    }
    async flowCheckedRouter(contact) {
        if (contact.template !== MASTER) {
            return;
        }
        this.children = await this.getChildren(contact.shortName, this.tenantId);
        if (this.children !== undefined) {
            contact.blocked = false;
            const newList = new ItemsInHeader();
            newList.id = contact.shortName;
            newList.name = contact.name;
            newList.applications = [];
            newList.applications.push(contact);
            this.removeToListContact(this.applications, contact);
            this.children.forEach(element => {
                this.changeStateBots(element, true);
                newList.applications.push(element);
                this.removeToListContact(this.applications, element);
                this.addChildrenToListChecked(element);
            });
            this.listApplicationsWithChildren.itemsInHeader.push(newList);
            this.addChildrenToTotal(contact);
        }
    }
    async flowUncheckedRouter(contact) {
        if (contact.template !== MASTER) {
            return;
        }
        const listItemsHeaderToRemove = this.listApplicationsWithChildren.itemsInHeader.find(i => i.id === contact.shortName);
        if (listItemsHeaderToRemove !== null && listItemsHeaderToRemove !== undefined) {
            listItemsHeaderToRemove.applications.forEach(element => {
                this.removeToListContact(this.checkedApplications, element);
                this.removeChildrenToTotal(element);
                this.deleteCounter(element);
                if (element.showApplication !== false) {
                    this.changeStateBots(element, false);
                    this.applications.push(element);
                }
            });
            const indexToRemove = this.listApplicationsWithChildren.itemsInHeader.findIndex((i) => i.id == listItemsHeaderToRemove.id);
            this.listApplicationsWithChildren.itemsInHeader.splice(indexToRemove, 1);
        }
        else {
            this.deleteCounter(contact);
        }
    }
    changeStateBots(contact, status) {
        contact.checked = status;
        contact.blocked = status;
        contact.disabled = status;
    }
    async getChildren(shortName, tenantId) {
        return await this.ApplicationService2.getApplicationsWithChildren(shortName, tenantId);
    }
    addChildrenToListChecked(element) {
        const indexToInclude = this.checkedApplications.findIndex((c) => element.shortName === c.shortName);
        if (element.template === AI_AGENT) {
            return;
        }
        if (indexToInclude === -1) {
            this.checkedApplications.push(element);
            this.addCounter(element);
        }
        return;
    }
    removeToListContact(listApplications, contact) {
        const indexToRemove = listApplications.findIndex((application) => contact.shortName === application.shortName);
        if (indexToRemove === -1) {
            if (contact.showApplication === undefined && contact.template === BUILDER) {
                contact.showApplication = false;
            }
        }
        else {
            if (contact.showApplication === undefined) {
                contact.showApplication = true;
            }
            listApplications.splice(indexToRemove, 1);
        }
    }
    addChildrenToTotal(contact) {
        const item = this.listApplicationsWithChildren.itemsInHeader.find(i => i.id == contact.shortName);
        if (item !== undefined) {
            item.applications.forEach(o => {
                this.counterTotal = this.counterTotal + 1;
            });
        }
    }
    removeChildrenToTotal(contact) {
        const item = this.listApplicationsWithChildren.itemsInHeader.find(i => i.id == contact.shortName);
        if (item !== undefined) {
            item.applications.forEach(o => {
                this.counterTotal = this.counterTotal - 1;
            });
        }
    }
    createListCheckedInExhibition() {
        this.checkedApplications = this.checkedApplications.filter(app => app.template !== AI_AGENT);
        this.listApplicationsWithChildren.itemsInHeader.forEach(item => {
            item.applications = item.applications.filter(app => app.template !== AI_AGENT);
        });
        this.checkedInExhibitionApplicationsStepTwo = angular.copy(this.checkedApplications);
        this.listApplicationsWithChildren.itemsInHeader.forEach(item => {
            item.applications.forEach(element => {
                const indexToRemove = this.checkedInExhibitionApplicationsStepTwo.findIndex(o => o.shortName === element.shortName);
                if (indexToRemove !== -1) {
                    this.checkedInExhibitionApplicationsStepTwo.splice(indexToRemove, 1);
                }
            });
        });
    }
    async getHistoricMigration(tenantId, groupIdMigration) {
        this.listHistoricMigration = await this.ApplicationService2.getHistoricApplications(tenantId, groupIdMigration);
    }
    reloadHistoric() {
        this.$window.location.href = this.$window.location.origin + '/application/historic';
        return;
    }
    finishMigration() {
        this.listApplicationsWithChildren.itemsInHeader = [];
        this.checkedInExhibitionApplicationsStepTwo = [];
        this.checkedMasterApplications = [];
        this.checkedBuilderApplications = [];
    }
    async configPagination() {
        this.setInitPagination();
        this.setTotalPagination();
        this.validateMinimumToShowPagination();
    }
    async setInitPagination() {
        this.page = 1;
        this.totalNumberPages = 0;
        this.totalNumberItems = 0;
        this.itemsPerPage = 40;
    }
    async loadPerItem() {
        this.applications = this.isQueryingApplications ? this.searchResults : this.applicationsBuffer;
        this.applications = this.isPaginationHomeInApplication ? this.applications.filter((app, index) => index < this.itemsPerPage) : this.applications;
    }
    validateMinimumToShowPagination() {
        if (this.totalApplications > this.itemsPerPage) {
            this.showPagination = true;
        }
        if (this.itemsPerPage < this.totalApplications) {
            this.showPagination = true;
        }
    }
    async loadSkipPage() {
        this.applications = this.isQueryingApplications ? this.searchResults : this.applicationsBuffer;
        this.applications = this.applications.slice(this.skip, this.skip + this.itemsPerPage);
    }
}
MoveApplicationToTenantController.$inject = ['$state', '$rootScope', '$window', 'ApplicationService2', 'LoadingService', 'ngToast', '$translate', 'ModalService', 'AccountService2', 'BlipService', 'AuthenticationService', 'ContextProcessorService', '$stateParams', 'TenantService', 'SegmentService', 'BLIP_DOMAIN', 'SharedToastsService', '$scope', 'BlipToastService'];
